<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <v-row no-gutters>
          <v-col>
            <p class="mb-1 text-caption">Kind</p>
            <p class="display-1 accent--text">{{ getCommDetail.kind | customPlaceholder }}</p>

            <v-row>
              <v-col>
                <div class="d-flex align-center mb-1">
                  <p class="mb-0 mr-1 text-caption">System</p>
                  <BaseInfoTooltip top>The system where the comm is being sent from</BaseInfoTooltip>
                </div>
                <p><b>{{ getCommDetail.system | customPlaceholder }}</b></p>
              </v-col>

              <v-col>
                <div class="d-flex align-center mb-1">
                  <p class="mb-0 mr-1 text-caption">Direction</p>
                  <BaseInfoTooltip top>Direction indicates whether the call is incoming or outgoing</BaseInfoTooltip>
                </div>
                <p><b>{{ getCommDetail.direction | customPlaceholder }}</b></p>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <p class="mb-1 text-caption">Assigned agent</p>
                <p><b>{{ getCommDetail.assigned_agent | customPlaceholder }}</b></p>
              </v-col>

              <v-col>
                <p class="mb-1 text-caption">Assigned team</p>
                <p><b>{{ getCommDetail.assigned_team | customPlaceholder }}</b></p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <v-row no-gutters>
          <v-col>
            <p class="mb-1 text-caption">Timestamp</p>
            <p class="display-1 accent--text">{{ getCommDetail.timestamp | formatDate('YYYY-MM-DD HH:mm')}}</p>

            <v-row>
              <v-col>
                <div class="d-flex align-center mb-1">
                  <p class="mb-0 mr-1 text-caption">Duration</p>
                  <BaseInfoTooltip top>Duration of phone call</BaseInfoTooltip>
                </div>
                <p><b>{{ getCommDetail.duration_secs | customPlaceholder }}</b></p>
              </v-col>

              <v-col>
                <p class="mb-0 mr-1 text-caption">Duration unit</p>
                <p><b>Seconds</b></p>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <p class="mb-0 mr-1 text-caption">Call notes</p>
                <p><b>{{ getCommDetail.contents | customPlaceholder }}</b></p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table :headers="headers" :items="getCommDetail.participants" hide-default-footer>
          <template v-slot:item.participant_type="{ item }">{{ item.participant_type | customPlaceholder }}</template>
          <template v-slot:item.caller_name="{ item }">{{ item.caller_name | customPlaceholder }}</template>
          <template v-slot:item.created_time="{ item }">{{ item.created_time | formatDate | customPlaceholder }}</template>
          <template v-slot:item.updated_time="{ item }">{{ item.updated_time | formatDate | customPlaceholder }}</template>
          <template v-slot:item.duration="{ item }">{{ item.duration | customPlaceholder }}</template>
          <template v-slot:item.duration_units="{ item }">Seconds</template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        headers: [
          { text: 'Participant type', sortable: false, value: 'participant_type' },
          { text: 'Name', sortable: false, value: 'caller_name' },
          { text: 'Created time', sortable: false, value: 'created_time' },
          { text: 'Update time', sortable: false, value: 'updated_time' },
          { text: 'Duration', sortable: false, value: 'duration' },
          { text: 'Duration unit', sortable: false, value: 'duration_units' },
        ],
      }
    },

    computed: {
      ...mapGetters('comms', ['getCommDetail']),
    },
  }
</script>